"use strict";
var _a = require('./viewer').default, createControllers = _a.createControllers, initAppForPage = _a.initAppForPage;
module.exports = {
    initAppForPage: initAppForPage,
    createControllers: createControllers,
    exports: {},
};
